import { getStorage } from "@/utils/getStorage";

export const userPersistConfig = {
    key: 'user',
    storage: getStorage(),
    blacklist: ['isShownCarSelection', 'loading', 'error'],
};